import React, { useState } from "react";
import { compose, graphql } from "react-apollo";
import Table from "components/Table/Table";
import { withQuery } from "containers/withQuery";
import PencilButton from "components/ActionButtons/PencilButton";
import DeleteButton from "components/ActionButtons/DeleteButton";
import AlertModal from "components/AlertModal/AlertModal";
import translateErrorMessage from "utils/translateErrorMessage";
import { withSnackbarConsumer, Color } from "contexts/SnackbarContext/SnackbarContext.jsx";
import { ACTUATORS_QUERY } from "../generalRegisterQueries";
import { DELETE_ACTUATOR_MUTATION } from "../generalRegisterMutations";
import ActuatorEdit from "./ActuatorEdit";
import { actuatorTypes } from "../enumTypes";

const headers = [
  {
    label: "Id", key: "id",
  },
  {
    label: "Nome", key: "name",
  },
  {
    label: "Tipo", key: "type",
  },
  {
    label: "Card", key: "plantLocation",
  },
  {
    label: "Modo de Manutenção", key: "maintenanceMode",
  },
  {
    label: "", key: "action",
  },
  {
    label: "", key: "delete",
  },
];

const ActuatorsTable = ({
  actuators,
  deleteActuator,
  snackbarContext,
}) => {
  const [editId, setEditId] = useState(null);

  const openEdit = (id) => {
    setEditId(id);
  };

  const closeEdit = () => {
    setEditId(null);
  };

  const handleDeleteActuator = async (id) => {
    try {
      await deleteActuator({
        variables: { id },
        refetchQueries: [{ query: ACTUATORS_QUERY }],
      });

      snackbarContext.setNotificationTimeOut(
        Color.success,
        "Atuador deletado."
      );
    } catch (error) {
      snackbarContext.setNotificationTimeOut(
        Color.danger,
        translateErrorMessage(error)
      );
    };
  };

  const handleDeleteModal = (id) => {
    AlertModal.fire({
      title: "Deletar Atuador",
      html: "Deseja deletar o atuador selecionado?",
      type: "error",
      showCancelButton: true,
      confirmButtonColor: "#1D84C6",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Voltar",
      reverseButtons: true,
    }).then(({ value }) => {
      if (value) {
        handleDeleteActuator(id);
      }
    });
  };

  const buildTableItems = () => (
    [...actuators]
      .sort((a, b) => a.id - b.id)
      .map(actuator => ({
        ...actuator,
        plantLocation: actuator.plantLocation ? actuator.plantLocation.name : "",
        type: actuatorTypes[actuator.type],
        maintenanceMode: actuator.maintenanceMode ? "Habilitado" : "Desabilitado",
        action: (
          <PencilButton
            onPencilEditClick={() => openEdit(actuator.id)}
          />
        ),
        delete: (
          <DeleteButton
            onClick={() => handleDeleteModal(actuator.id)}
          />
        ),
      }))
  );

  return (
    <React.Fragment>
      <Table
        headers={headers}
        matchHeaders
        items={buildTableItems()}
      />
      {editId && (
        <ActuatorEdit id={editId} onFinishEdit={closeEdit} />
      )}
    </React.Fragment>
  );
};

export default compose(
  withQuery({ query: ACTUATORS_QUERY }),
  graphql(DELETE_ACTUATOR_MUTATION, { name: "deleteActuator", }),
  withSnackbarConsumer,
)(ActuatorsTable);
